import React from 'react';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Button, Grid, Typography } from '@material-ui/core';

import { DashboardContext } from '../DashboardContext';
import ErrorImg from '../../../assets/error.svg';
import { DashboardStatus } from '../enums/DashboardStatus';

const useStyles = makeStyles((theme) => createStyles({
    item: {
        margin: theme.spacing(3),
        maxWidth: '730px',
        textAlign: 'center',
        overflow: 'hidden'
    },
    icon: {
        fontSize: '100px',
        marginTop: theme.spacing(3),
    },
    container: {
        marginTop: theme.spacing(3),
        heigth: '90vh'
    }
}));

export function DashboardError() {
    const classes = useStyles();

    const dashboardContext = React.useContext(DashboardContext);
    
    return (
        <Grid
            container
            direction="column"
            alignItems="center"
            justify="center"
            className={classes.container}>
            <Typography variant="h3" className={classes.item}>
                Não foi possível carregar o dashboard
            </Typography>
            {dashboardContext.errorMessage && (
                <Typography variant="body1" className={classes.item}> 
                    {dashboardContext.errorMessage}
                </Typography>
            )}
            <div className={classes.icon}>
                <img src={ErrorImg} alt="" />
            </div>
            <Button 
                variant="contained" 
                color="primary"
                size="large"
                onClick={() => dashboardContext.setDashboardStatus(DashboardStatus.DEFAULT)}>
                Recarregar
            </Button>
        </Grid>
    );
}